import { desktopSmall, mobile, tablet, tv } from 'app/device';
import styled, { css } from 'styled-components';

export const GamesWrapper = styled.div.attrs(() => ({
    id: 'GamesWrapper',
}))`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding-top: ${(props) => (props.isDiscoveryOffer ? '8rem' : '0')};
    overflow-x: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        width: 0 !important;
    }

    ${tv(css`
        width: 100vw;
    `)}

    ${mobile(css`
        width: 100vw;
    `)}
`;

export const LeadingGame = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin: 0 auto;
    height: 75vh;
    flex-shrink: 0;
    padding-bottom: 50px;
    width: 100%;

    ${tablet(css`
        height: 80vh;
        padding-bottom: 20px;
    `)}

    ${desktopSmall(css`
        height: 80vh;
        padding-bottom: 30px;
    `)}

    ${mobile(css`
        height: ${(props) => (props.showEditorials ? '85vh' : '75vh')};
        padding-bottom: 20px;
    `)} 

  ${tv(css`
        height: 65vh;
    `)};
`;

export const NoGamesFound = styled.div`
    margin-top: ${(props) => (props.small ? '10vh' : '30vh')};
    font-size: 2rem;
    text-align: center;
    ${mobile(css`
        font-size: 1.4rem;
    `)}
`;
